export default __webpack_public_path__ + "static/media/Piasa.1c8d650c.png";